import styled, {keyframes} from 'styled-components';
import TestIMG from '../../../assets/broadcast/center-wait.jpg';

export const StreamingWrapper = styled.div`
    position: relative;
    width: 100%;
    //width: 78vw;
    //height: 89vh;
    overflow: hidden;
    background-color: #1c1c1c;
`;

export const StreamGrid = styled.div<{
    $col: number;
    $row: number;
    $gap?: string;
    $justifyItems?: string;
}>`
    height: 100%;
    display: grid;
    grid-template-rows: repeat(${({$col}) => $col}, 1fr);
    grid-template-columns: repeat(${({$row}) => $row}, 1fr);

    gap: ${({$gap = '10px'}) => $gap};
    column-gap: ${({$gap = '10px'}) => $gap};
    ${({$gap = '10px'}) => $gap};

    justify-items: ${({$justifyItems = 'start'}) => $justifyItems};
    align-items: stretch;
    width: 100%;
`;

export const BackgroundVideo = styled.div<{
    $isFullScreen: boolean;
    $isWatching?: boolean;
}>`
    object-fit: cover;
    overflow: hidden;
    transition: all 0.3s ease-in-out;

    width: 100%;
    aspect-ratio: ${({$isWatching}) => ($isWatching ? '16 / 9' : '16 / 7.1')};
    border-radius: 1rem;
    position: relative;
    top: auto;
    left: auto;
    z-index: auto;
    display: inline-flex;
    justify-content: center;

    ${(props) =>
            props.$isFullScreen &&
            `
        position: fixed;
        width: 100vw;
        height: 100vh;
        aspect-ratio: auto;
        top: 0;
        left: 0;
        z-index: 100;
        border-radius: 0px;
    `}
    video, img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 0.3s ease-in-out;
    }
`;

export const BackgroundImg = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 99;
    background-color: #000;
`;

export const FullScreenIcon = styled.div<{ $isFullScreen: boolean; $show: boolean; $focused: boolean }>`
    position: ${({$isFullScreen}) => ($isFullScreen ? 'fixed' : 'absolute')};
    bottom: 6rem;
    right: ${({$isFullScreen}) => ($isFullScreen ? '4vw' : '1rem')};
    z-index: 100;
    display: flex;
    background-color: #1f1f1f;
    padding: 0.7rem;
    border-radius: 1.25rem;
    transition: all 0.3s ease-in-out;
    animation: ${({$show}) => ($show ? slideUp : slideDown)} 0.5s forwards;
    width: 60px;
    height: 60px;
    border: ${({$focused}) => ($focused ? '3px solid #3FB5EC' : 'none')};
`;

export const PlayerWrapper = styled.div`
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #000;
    overflow: hidden;
`;

const slideUp = keyframes`
    from {
        transform: translateY(30rem);
    }
    to {
        transform: translateY(0);
    }
`;

const slideDown = keyframes`
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(30rem);
    }
`;

export const LayoutButton = styled.div<{ $isFullScreen: boolean; $show: boolean }>`
    position: ${({$isFullScreen}) => ($isFullScreen ? 'fixed' : 'absolute')};
    bottom: 6rem;
    left: 1rem;
    z-index: 98;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #1f1f1f;
    padding: 0.7rem;
    border-radius: 1.25rem;
    transition: all 0.3s ease-in-out;
    gap: 10px;
    animation: ${({$show}) => ($show ? slideUp : slideDown)} 0.5s forwards;
`;

export const LayoutItem = styled.div.attrs<{$focused: boolean; $disabled?: boolean }>(props => ({$disabled: props.$disabled ?? false}))`
    width: 70px;
    height: 60px;
    display: flex;
    justify-content: center;
    outline: ${({$focused}) => ($focused ? '3px solid #3FB5EC' : 'none')};
    outline-offset: -3px;
    & > * {
        opacity: ${({$disabled}) => ($disabled ? 0.4 : 1)};
        filter: ${({$disabled}) => ($disabled ? 'grayscale(100%)' : 'none')};
    }
`;

export const TestRedIcon = styled.div`
    width: 50px;
    height: 50px;
    position: fixed;
    top: 5vh;
    left: 3vw;
    border-radius: 30px;
    background-color: red;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

const fadeOut = keyframes`
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
`;

export const SplashImg = styled.div<{ $show: boolean }>`
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    aspect-ratio: 16 / 9;
    background-image: url(${TestIMG});
    z-index: 999;
    transition: all 0.3s ease-in-out;
    animation: ${({$show}) => ($show ? fadeIn : fadeOut)} 0.5s forwards;
`;

export const PleaseWaitText = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: xx-large;
    font-weight: bolder;
`;
